import React from 'react';
import { Link, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import './styles.css';
import '../SharedUtils/themeColors/backgroundColor.css';
import RenderingStyling from '../../../lib/RenderingStyling';
import { getTrackingAttributes } from '../SharedUtils/utils';
import StickyNavHook from './StickyNavHook';

const AdvancedStickyNav = ({ fields, rendering, sitecoreContext }) => {
  const widgetClasses = ['o-widget', 'c-advanced-sticky-nav'];
  const trackingAttributes = getTrackingAttributes(fields);
  var maxCount = 6;
  if (fields?.CallToAction?.value?.href) {
    widgetClasses.push('with-cta');
    maxCount = maxCount - 1;
  }

  const flattenRenderings = (placeholder) => {
    const result = [];

    function traverse(items) {
      if (!items || !Array.isArray(items)) return;

      items.forEach((item) => {
        result.push(item);

        if (item.placeholders) {
          Object.values(item.placeholders).forEach(traverse);
        }
      });
    }

    traverse(placeholder);
    return result;
  };

  const allRenderings = flattenRenderings(sitecoreContext.route.placeholders['jss-main']);

  const navLinks =
    fields?.NavLinkList?.map((navLinkId) => {
      const navLink = navLinkId;
      if (!navLink) return null;

      let targetElementID = '';

      if (navLink?.fields?.LinkTargetElementId?.value?.trim()) {
        targetElementID = navLink.fields.LinkTargetElementId.value;
      }
      const match = allRenderings.find(
        (r) =>
          r?.dataSource?.replace(/[{}]/g, '').toUpperCase() ===
          navLink.fields.LinkTargetElement?.id.toUpperCase()
      );

      if (match) {
        targetElementID = 'c-' + match.uid?.replace(/[{}]/g, '');
      }
      StickyNavHook(targetElementID);

      return {
        ...navLink,
        targetElementID,
      };
    }).filter(Boolean) || [];

  var slicedNavLinks = navLinks.slice(0, maxCount);
  return (
    <div {...RenderingStyling(rendering?.componentName)} className={widgetClasses?.join(' ')}>
      <div className="row">
        <div className="column">
          <div className="c-advanced-sticky-nav-anchor-bar-text">
            <div className="dropdown-mobile-text">{fields?.DropdownLabelMobile?.value}</div>{' '}
            <i className="arrow"></i>
            <div className="mobile-cta">
              <i className="arrow mobile"></i>
              {fields?.CallToAction?.value?.href && (
                <Link
                  field={fields?.CallToAction?.value}
                  className="mobile c-button c-cta-button is-primary"
                  role="button"
                  {...trackingAttributes}
                />
              )}
            </div>
          </div>
          <div className="c-advanced-sticky-nav-content" role="contentinfo">
            <ul>
              {slicedNavLinks?.map((link, idx) => (
                <li key={idx}>
                  {link?.fields?.CallToAction?.value?.href ? (
                    <Link
                      field={link?.fields?.CallToAction?.value}
                      className="c-button c-cta-button is-primary"
                      role="button"
                    />
                  ) : (
                    <a
                      href={`#${link?.targetElementID}`}
                      role="link"
                      aria-label={link?.fields?.LinkTextLabel?.value}
                      title={link?.fields?.LinkTextLabel?.value}
                      data-offset={link?.fields?.TargetTopOffset?.value}
                      data-track={link?.fields?.DataTrackEnable?.value}
                      data-track-value={link?.fields?.DataTrackValue?.value}
                      data-track-destination={link?.fields?.DataTrackDestination?.value}
                    >
                      {link?.fields?.LinkTextLabel?.value == ''
                        ? 'No Title'
                        : link?.fields?.LinkTextLabel?.value}
                    </a>
                  )}
                </li>
              ))}
              {fields?.CallToAction?.value?.href && (
                <Link
                  field={fields?.CallToAction?.value}
                  className="c-button c-cta-button is-primary"
                  role="button"
                  {...trackingAttributes}
                />
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withSitecoreContext()(AdvancedStickyNav);
